import { useEffect, useState } from "react";
import Modal from "./modal";
import Spinner from "./spinner";
import ReactDatePicker from "react-datepicker";
import { he } from "date-fns/locale";
import styles from "../styles/_components/createCouponModal.module.scss";
import ReactSwitch from "react-switch";
import SERVICES from "../api/services/SERVICES";
import { format } from "date-fns";
import { toast } from "react-toastify";
import COUPONS from "../api/services/COUPONS";

const EditCouponModal = ({ setIsOpen, couponId, setResponseStatus }) => {
  const [expiryDate, setExpiryDate] = useState("");
  const [allowMultipleUsesPerUser, setAllowMultipleUsesPerUser] =
    useState(false);
  const [quantity, setQuantity] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [validService, setValidService] = useState("");
  const [validServices, setValidServices] = useState([]);

  const [loading, setLoading] = useState("");

  const [services, setServices] = useState(null);

  // FETCH COUPON BY ID
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await COUPONS.get_coupon_by_id(couponId);
        setExpiryDate(new Date(res.coupon.expiryDate));
        setAllowMultipleUsesPerUser(res.coupon.allowMultipleUsesPerUser);
        setQuantity(res.coupon.quantity);
        setIsActive(res.coupon.isActive);
        setValidServices(res.coupon.validServices);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  const handleEditCoupon = async () => {
    let payload = {
      expiryDate: format(new Date(expiryDate), "yyyy-MM-dd"),
      allowMultipleUsesPerUser,
      isActive,
      validServices,
    };

    if (quantity) {
      payload.quantity = quantity;
    }

    try {
      setLoading(true);
      const res = await COUPONS.edit_coupon(couponId, payload);
      toast.success(res.data.message);
      setIsOpen(false);
      setResponseStatus(true);
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  let businessId = localStorage.getItem("user_id");
  businessId = JSON.parse(businessId);

  // FETCH SERVICES
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await SERVICES.get_all({ business_id: businessId });
        setServices(res.data.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  return (
    <Modal setIsOpen={setIsOpen} onClick={() => null} type={1}>
      <div className={styles.container}>
        {/* QUANTITY */}
        <div className={styles.field}>
          <input
            type="number"
            name="quantity"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            placeholder="כמות למימוש"
          />
        </div>

        {/* EXPIRY DATE */}
        <div className={styles.field}>
          <ReactDatePicker
            selected={expiryDate}
            onChange={setExpiryDate}
            locale={he}
            placeholderText="תוקף *"
            wrapperClassName={styles.exp}
            minDate={new Date()}
          />
        </div>

        {/* SWITCH ROW */}
        <div className={styles.switchRow}>
          {/* STATUS */}
          <div className={styles.switchContainer}>
            <ReactSwitch
              checked={isActive}
              onChange={(e) => {
                setIsActive(e);
              }}
              checkedHandleIcon={false}
              uncheckedHandleIcon={false}
              checkedIcon={false}
              uncheckedIcon={false}
              onHandleColor={"#ffffff"}
              offHandleColor={"#ffffff"}
              onColor={"#d00254"}
              offColor={"#d3d3d3"}
              className={styles.switch}
            />
            <p>סטטוס</p>
          </div>

          {/* ALLOW MULTIPLE USES PER USER */}
          <div className={styles.switchContainer}>
            <ReactSwitch
              checked={allowMultipleUsesPerUser}
              onChange={(e) => {
                setAllowMultipleUsesPerUser(e);
              }}
              checkedHandleIcon={false}
              uncheckedHandleIcon={false}
              checkedIcon={false}
              uncheckedIcon={false}
              onHandleColor={"#ffffff"}
              offHandleColor={"#ffffff"}
              onColor={"#d00254"}
              offColor={"#d3d3d3"}
              className={styles.switch}
            />
            <p>לקוח יכול לממש יותר מפעם אחת</p>
          </div>
        </div>

        {/* VALID SERVICES */}
        <div className={styles.field}>
          <select
            name="validService"
            value={validService}
            onChange={(e) => {
              setValidService(e.target.value);
              if (!validServices.includes(e.target.value)) {
                setValidServices((prev) => [...prev, e.target.value]);
              }
            }}
          >
            <option value="" disabled selected>
              הקצאה לשירותים ספציפים
            </option>
            {services?.map((i) => (
              <option key={i._id} value={i._id}>
                {i.name}
              </option>
            ))}
          </select>
        </div>

        {/* SERVICES BOX */}
        {services && (
          <div className={styles.box}>
            {validServices.length > 0 ? (
              validServices.map((i) => (
                <div
                  className={styles.service}
                  onClick={() =>
                    setValidServices((prev) => prev.filter((x) => x !== i))
                  }
                  key={i}
                >
                  <span>x</span>
                  {services?.find((j) => j._id === i)?.name}
                </div>
              ))
            ) : (
              <p>ניתן לממש על כל השירותים</p>
            )}
          </div>
        )}

        <button onClick={handleEditCoupon} className={styles.button}>
          {loading ? <Spinner /> : "עריכה"}
        </button>
      </div>
    </Modal>
  );
};

export default EditCouponModal;
